<template>
  <div class="text-center" style="font-size: 30px">
    <b>FICHA DEL JUGADOR</b> <v-btn v-if="is_authenticated" type="button" color="primary" @click="redirect('')" class="mr-4">Editar Jugador</v-btn>
  </div>
  <br>
  <br>
  <v-row v-if="person">
    <v-col cols="12" md="4" offset-md="2">
      <div class="text-center" style="font-size: 30px">
        <b>Nombres</b>
        <p>{{person.firstName}} {{person.secondName}}</p>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="-2">
      <div class="text-center" style="font-size: 30px">
        <b>Apellidos</b>
        <p>{{person.lastName}} {{person.lastNameSecond}}</p>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="2">
      <div class="text-center" style="font-size: 30px">
        <b>Titulo</b>
        <p v-if="person.title">{{person.title}}</p>
        <p v-else>N/A</p>
      </div>
    </v-col>
      <v-col cols="12" md="4" offset-md="-2">
      <div class="text-center" style="font-size: 30px">
        <b>Fecha Nacimiento</b>
        <p>{{person.birthday}}</p>
      </div>
    </v-col>
      <v-col cols="12" md="4" offset-md="2">
      <div class="text-center" style="font-size: 30px">
        <b>Club</b>
        <p v-if="person.club">{{person.club.name}}</p>
        <p v-else>Sin informacion</p>
      </div>
    </v-col>
      <v-col cols="12" md="4" offset-md="-2">
      <div class="text-center" style="font-size: 30px">
        <b>ID</b>
        <p v-if="person.federationId">{{person.federationId}}</p>
        <p v-if="is_authenticated && !person.federationId">Si asigna id porfavor verificar que no este duplicado</p>
        <v-btn v-if="is_authenticated && !person.federationId" type="button" color="primary" @click="asignar('')" class="mr-4">Asignar ID</v-btn>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="2">
      <div class="text-center" style="font-size: 30px">
        <b>Elo Internacional</b>
        <p>{{person.elo_inter}}</p>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="-2">
      <div class="text-center" style="font-size: 30px">
        <b>Elo nacional</b>
        <p>{{person.elo_nat}}</p>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="2">
      <div class="text-center" style="font-size: 30px">
        <b>K Elo nacional</b>
        <p>{{person.factor}}</p>
      </div>
    </v-col>
    <v-col cols="12" md="4" offset-md="-2">
      <div class="text-center" style="font-size: 30px">
        <b>Canon 2025</b>
        <p v-if="person.canon">Pagado</p>
        <p v-else> No pagado</p>
      </div>
    </v-col>
  </v-row>
  <v-row v-if="person">
      <v-col cols="6">

      <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Ver
        </th>
        <th class="text-center">
          Inicio Periodo
        </th>
        <th class="text-center">
          Final Periodo
        </th>
        <th class="text-center">
          Elo
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="elos in person.periodelos"
        :key="elos.id"
      >
        <td class="text-center"><a :href="'/resultados_jugador_periodo/'+elos.id" style="color:blue">#</a></td>
        <td class="text-center">{{ elos.period.start_date_formated }}</td>
        <td class="text-center">{{ elos.period.end_date_formated }}</td>
        <td class="text-center">{{ elos.elo }}</td>
      </tr>
    </tbody>
  </v-table>
    </v-col>

  </v-row>
</template>

<script>

import gql from "graphql-tag";
import {mapState} from "vuex";
import axios from "axios";
export default {
  props:["id"],
  apollo: {
    person: {query: gql` query($id:String!){
       person(id:$id){
        id
        title
        firstName
        secondName
        lastName
        lastNameSecond
        canon
        birthday:birthdayFormated
        club:clubBasic {
          name
        }
        federationId
        elos
        factor
        elo_nat:eloNat
        elo_inter:eloInter
        periodelos:elosHistoric{
          id
          period{
            start_date_formated:startDateFormated
            end_date_formated:endDateFormated
          }
          elo
        }
      }

    }`,
      variables() {return {"id" :this.id}},
    },
  },
    name:"NewsChess",
  data() {
    return {
      person:null,
      tour_sel:"",
    }
  },
  components: {

  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {
    roundNumberToDecimal(number, factor) {
      if(!number){
        return 0.0
      }
      return parseFloat((1*number)*(1*factor)).toFixed(1); // Redondear a un decimal
    },
    redirect(){
      window.location.href = '/crear_jugador/' + this.id
    },
    asignar(){
      let self = this
      axios.post('/crear_id/', {id:this.id}).then(() => {
          window.location.href = '/player/' + self.id
      })
    },
  },
  watch:{

  }
}
</script>
<style>

</style>
